import { CameraAlt } from '@mui/icons-material'
import { Alert, Button, Input, Stack, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { FileUploader } from "react-drag-drop-files";
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

const fileTypes = ["JPG", "JPEG", "PNG", "GIF", "WEBP"];

const LoadImg = ({ selectImage, api }) => {

    const { t, i18n } = useTranslation(['translation']);

    const [fileError, setFileError] = useState(false);
    const [image, setImage] = useState('');

    useEffect(() => {
        if(api !== undefined && api.conf && api.conf.visualsearch_image)
            setImage(api.conf.visualsearch_image);
        else
            setImage('https://visidea.ai/wp-content/uploads/2022/03/vs4-1536x1322.png');
    }, [api]);

    const checkImage = (file) => {
        if (!file.name.match(/\.(jpg|jpeg|png|webp|JPG|JPEG|PNG|WEBP)$/)) {
            setFileError(true);
        } else {
            selectImage(file);
        }
    }

    const handleChange = (file) => {
        selectImage(file);
    };

    const upload = (<Button
        className='fileuploader-button'
        variant="outlined"
        startIcon={<CameraAlt />}
        component="label"
        sx={{
            color: '#1D252D',
            width: '50%',
            // left: '25%',
            borderColor: '#1D252D',
            '&:hover': {
                borderColor: '#1D252D',
                color: '#1D252D',
            }
        }}
        >
            {isMobile ?
                <>{t('Snap a photo')}</>
                :
                <>{t('Upload image')}</>
            }
        <input
            type="file"
            hidden
            name="myImage"
            accept="image/*"
            capture="environment"
            onChange={(event) => {
                console.log("----- First image loading -----")
                checkImage(event.target.files[0]);
            }}
        />
    </Button>)

    const dropZone = (
        <Box
            sx={{
                color: '#1D252D',
                width: '100%',
                margin: 'auto',
                paddingTop: '10px',
                paddingBottom: '10px',
                borderColor: '#1D252D',
                '&:hover': {
                    borderColor: '#1D252D',
                    color: '#1D252D',
                    borderStyle: 'dashed',
                    borderWidth: '3px',
                    borderRadius: '7px'
                },
                borderStyle: 'dashed',
                borderWidth: '3px',
                borderRadius: '7px'
            }}
        >
            <Stack direction='column'>
                <Typography variant="h6" sx={{textAlign:'center'}}>
                    {t('Drag & Drop image')}
                </Typography>
                <Typography variant="body2" paddingBottom='5px' sx={{textAlign:'center'}}>
                    {t('or')}
                </Typography>
                {upload}
            </Stack>
        </Box>
    )


    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
        >
            <Stack spacing={1}>
                <Typography variant='h4'>
                    {t('Snap and Search')}
                </Typography>
                <Typography variant='span' sx={{ maxWidth: '550px', paddingBottom: '20px' }}>
                    {t('Upload a photo of your favourite styles to find matching products')}.
                </Typography>
                <img
                    alt="visual search"
                    src={image}
                    style={{
                        width: '100%',
                        maxWidth: '550px',
                        height: 'auto'
                    }}
                />
                {/* accept="image/*"" */}
                <Box sx={{ width: '100%' }} className='fileuploader-container'>
                    {isMobile ?
                        <div className='fileuploader-mobile'><FileUploader handleChange={handleChange} name="file" types={fileTypes} hoverTitle={" "} children={upload} /></div>
                        :
                        <div className='fileuploader-desktop'><FileUploader handleChange={handleChange} name="file" types={fileTypes} hoverTitle={" "} children={dropZone} /></div>
                    }
                    {/* <FileUploader handleChange={handleChange} name="file" types={fileTypes} hoverTitle={" "} children={dropZone} /> */}
                </Box>

                {
                    fileError ?
                        <Alert
                            sx={{
                                paddingLeft: '35%'
                            }}
                            severity="error"
                        >
                            {t('Select an image file')}
                        </Alert>
                        :
                        <></>
                }
            </Stack>
        </Box>
    )
}

export default LoadImg